import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';


@Component({
    template: `<div>{{error}}</div>`
})
export class OktaCallbackComponent implements OnInit {

    error: string;

    constructor(
        private router: Router,
        private oktaAuthService: OktaAuthService
    ) {
        // TO DO: We might not need this component and just use
        // the one that comes with @okta/okta-angular ?
    }

    async ngOnInit(): Promise<void> {
        try {
            await this.oktaAuthService.handleAuthentication();
            const fromUri = this.oktaAuthService.getFromUri();
            window.location.replace(fromUri);
        }
        catch (ex) {
            console.log('OktaCallbackComponent error', ex);
        }
    }
}
